import { FC } from 'react';
import { SliderItem, GetHandleProps } from 'react-compound-slider';

type HandleProps = {
  domain: number[];
  handle: SliderItem;
  getHandleProps: GetHandleProps;
};

export const Handle: FC<HandleProps> = ({ domain: [min, max], handle: { id, value, percent }, getHandleProps }) => (
  <>
    {/* Dummy element to make the tooltip draggable */}
    <div
      style={{
        position: 'absolute',
        left: `${percent}%`,
        width: 40,
        height: 25,
        transform: 'translate(-50%, -100%)',
        cursor: 'grab',
        zIndex: 1,
      }}
      aria-hidden
      {...getHandleProps(id)}
    />
    <div
      role="slider"
      className="slider-handle"
      aria-label="slider"
      aria-valuemin={min}
      aria-valuemax={max}
      aria-valuenow={value}
      style={{
        left: `${percent}%`,
        cursor: 'grab',
      }}
      {...getHandleProps(id)}
    />
  </>
);
